<template>
  <div>
    <div class="card">
      <div class="card-header py-2">
        <Spinner v-if="loading" margin_right="10px" height="20px" />
        <b-form-checkbox v-else class="display-inline marginright5" v-model="checkedAll"></b-form-checkbox>
        <span @click="checkedAll = !checkedAll">Komoot Highlight Poi</span>
        <div style="float: right;">
          <img @click="expanded = !expanded" style="height: 13px; cursor: pointer;"
            :src="expanded ? icons.chevronUp : icons.chevronDown" />
        </div>
      </div>
      <div class="card-body" v-if="expanded">
        <b-form-checkbox class="display-inline marginright5" v-model="active"></b-form-checkbox>
        <span @click="active = !active">Active</span>
        <b-form-checkbox class="display-inline marginright5" v-model="inactive"></b-form-checkbox>
        <span @click="inactive = !inactive">Inactive</span>
      </div>
    </div>
    <MapPlace v-for="place of $store.state.maplasPlaces[$DataOrigin.komoothightlightpoi]" :key="place.id"
      :place="place"></MapPlace>
    <br>
    <div class="card">
      <div class="card-header py-2">
        <Spinner v-if="loading" margin_right="10px" height="20px" />
        <b-form-checkbox v-else class="display-inline marginright5" v-model="checkedAllOther"></b-form-checkbox>
        <span @click="checkedAllOther = !checkedAllOther">Komoot Other Poi</span>
        <div style="float: right;">
          <img @click="expandedOther = !expandedOther" style="height: 13px; cursor: pointer;"
            :src="expandedOther ? icons.chevronUp : icons.chevronDown" />
        </div>
      </div>
      <div class="card-body" v-if="expandedOther">
        <b-form-checkbox class="display-inline marginright5" v-model="activeOther"></b-form-checkbox>
        <span @click="activeOther = !activeOther">Active</span>
        <b-form-checkbox class="display-inline marginright5" v-model="inactiveOther"></b-form-checkbox>
        <span @click="inactiveOther = !inactiveOther">Inactive</span>
      </div>
    </div>
    <MapPlace v-for="place of $store.state.maplasPlaces[$DataOrigin.komoototherpoi]" :key="place.id" :place="place">
    </MapPlace>
  </div>
</template>

<script lang="ts">
import BaseComponent from './Base.vue';
import { EventBus } from '@/ts/EventBus';
import Place from '@/ts/Place';
import Photo from '@/ts/Photo';
import PlaceType from '@/ts/PlaceType';
import { AlertStatus, DataOrigin, DownloadStatus } from '@/ts/types';
import { defineComponent } from "vue";

export default defineComponent({
  extends: BaseComponent,
  data() {
    const checkedAllOther: boolean = false;
    const checkedAll: boolean = false;

    return {
      checkedAll,
      expanded: false,
      active: true,
      inactive: false,
      checkedAllOther,
      expandedOther: false,
      activeOther: true,
      inactiveOther: false,
      loading: false
    };
  },
  created() {
    EventBus.$on('downloadExternalData', () => this.downloadPlacesKomootPoi());
    EventBus.$on('toggleKomootPoi', () => {
      if (this.$options.result) {
        this.checkedAll = !this.checkedAll;
        this.checkedAllOther = !this.checkedAllOther;
      }
    });
    EventBus.$on('selectedAreaChanged', (newArea: string, oldArea: string) => this.onSelectedAreaChanged(newArea, oldArea));
  },
  methods: {
    isPointInSelectedArea(lat: number | string, lon: number | string) {
      // @ts-ignore
      const areaKey = window.selectedArea;
      if (!areaKey) return true;
      // @ts-ignore
      const area = window.areas[areaKey];
      if (!area || !area[0] || !area[1]) return true;
      const minLat = Math.min(area[0][0], area[1][0]);
      const maxLat = Math.max(area[0][0], area[1][0]);
      const minLon = Math.min(area[0][1], area[1][1]);
      const maxLon = Math.max(area[0][1], area[1][1]);
      const plat = Number(lat);
      const plon = Number(lon);
      if (Number.isNaN(plat) || Number.isNaN(plon)) return false;
      return (plat >= minLat && plat <= maxLat && plon >= minLon && plon <= maxLon);
    },

    onSelectedAreaChanged(newArea: string, oldArea: string) {
      if (this.$options.places_highlight) {
        for (const place of this.$options.places_highlight) {
          try { place.getMarker().removeFrom(window.mainmap); } catch (e) { }
        }
      }
      if (this.$options.places_other) {
        for (const place of this.$options.places_other) {
          try { place.getMarker().removeFrom(window.mainmap); } catch (e) { }
        }
      }
      if (this.$options.result) {
        this.processPlacesKomootPoi();
      }
    },
    downloadPlacesKomootPoi() {
      this.loading = true;
      const endPoint = window.apiHost + 'api/stringfield/komootpoi/';
      this.downloadUrlWithCache(endPoint, 'komootpoi', 'komootpoi.txt', null, true).then((response) => {
        this.$options.result = response[1].results;
        if (response[0] == DownloadStatus.cache_fresh) {
          this.createAlert(AlertStatus.success, this.$t('placesLoaded', [response[1].results.length]).toString(), 2000);
        }
        if (response[0] == DownloadStatus.api_fresh) {
          this.createAlert(AlertStatus.success, this.$t('placesDownloaded', [response[1].results.length]).toString(), 2000);
        }
        if (response[0] == DownloadStatus.cache_last) {
          this.createAlert(AlertStatus.warning, this.$t('placesLoaded', [response[1].results.length]).toString(), 2000);
        }
      }).catch((error) => {
        this.createAlert(AlertStatus.danger, this.$t('placesError').toString(), 2000);
      }).finally(() => {
        this.loading = false;
      });
    },
    processPlacesKomootPoi() {
      const places_highlight: Place[] = [];
      const places_other: Place[] = [];
      const yellow_circle = new PlaceType(1000000, 'parking', { 'color': 'yellow' }, 1);
      const red_circle = new PlaceType(1000001, 'other', { 'color': 'rgb(235, 30, 187)' }, 1);
      for (const responsePlace of this.$options.result) {
        let placetype = yellow_circle;
        let from_type = DataOrigin.komoototherpoi;
        if ((responsePlace.type == 'highlight_point') || (responsePlace.type == 'highlight_segment')) {
          placetype = red_circle;
          from_type = DataOrigin.komoothightlightpoi;
        }
        const place = new Place(responsePlace.id, responsePlace.name, '', this.roundNumber(responsePlace.lat, 5), this.roundNumber(responsePlace.lon, 5), placetype, false, JSON.parse(responsePlace.waypoints), from_type, responsePlace.is_active);
        place.createMarker();
        if (responsePlace.photos) {
          for (const responsePhoto of responsePlace.photos) {
            const photo = new Photo(1000000, 'Photo', '', responsePlace.id, null, window.mediaHost + 'komoot_poi/' + responsePhoto + '.jpg', window.mediaHost + 'komoot_poi/' + responsePhoto + '.jpg', window.mediaHost + 'komoot_poi/' + responsePhoto + '_thumb.jpg', false, 1, false);
            place.addPhoto(photo);
          }
        }
        if (this.isPointInSelectedArea(place.lat, place.lon)) {
          if (place.type.id == 1000001) {
            places_highlight.push(place);
          } else {
            places_other.push(place);
          }
        }
      }
      this.$options.places_highlight = places_highlight;
      this.$options.places_other = places_other;
      window.externalPlaces.komoothighlight = this.$options.places_highlight;
      window.externalPlaces.komootother = this.$options.places_other;
      this.onCheckedAllChanged();
      this.onCheckedAllOtherChanged();
    },
    onCheckedAllChanged() {
      if (this.$options.places_highlight) {
        for (const place of this.$options.places_highlight) {
          if (this.checkedAll) {
            if (place.is_active) {
              if (this.active) {
                place.getMarker().addTo(window.mainmap);
              } else {
                place.getMarker().removeFrom(window.mainmap);
              }
            } else {
              if (this.inactive) {
                place.getMarker().addTo(window.mainmap);
              } else {
                place.getMarker().removeFrom(window.mainmap);
              }
            }
          } else {
            place.getMarker().removeFrom(window.mainmap);
          }
        }
      } else {
        this.processPlacesKomootPoi();
      }
    },
    onCheckedAllOtherChanged() {
      if (this.$options.places_other) {
        for (const place of this.$options.places_other) {
          if (this.checkedAllOther) {
            if (place.is_active) {
              if (this.activeOther) {
                place.getMarker().addTo(window.mainmap);
              } else {
                place.getMarker().removeFrom(window.mainmap);
              }
            } else {
              if (this.inactiveOther) {
                place.getMarker().addTo(window.mainmap);
              } else {
                place.getMarker().removeFrom(window.mainmap);
              }
            }
          } else {
            place.getMarker().removeFrom(window.mainmap);
          }
        }
      } else {
        this.processPlacesKomootPoi();
      }
    }
  },
  watch: {
    "checkedAll": [{
      handler: "onCheckedAllChanged"
    }],
    "active": [{
      handler: "onCheckedAllChanged"
    }],
    "inactive": [{
      handler: "onCheckedAllChanged"
    }],
    "checkedAllOther": [{
      handler: "onCheckedAllOtherChanged"
    }],
    "activeOther": [{
      handler: "onCheckedAllOtherChanged"
    }],
    "inactiveOther": [{
      handler: "onCheckedAllOtherChanged"
    }]
  }
})


</script>